import React, { useState, useEffect } from "react";
import { FaArrowRight, FaDownload } from "react-icons/fa";

function Redherringprospectus() {
  const [financialData, setFinancialData] = useState([]);
  const [selectedPdf, setSelectedPdf] = useState(null);

  useEffect(() => {
    const fetchRHPData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_Backend_URL}/rhp/rhpDocument`
        );
        const result = await response.json();

        if (result.success) {
          setFinancialData(result.data.current);
        } else {
          console.error("Failed to fetch financial data");
        }
      } catch (error) {
        console.error("Error fetching financial data:", error);
      }
    };

    fetchRHPData();
  }, []);

  const handleViewClick = (fileUrl) => {
    setSelectedPdf(fileUrl);
  };

  const handleClosePreview = () => {
    setSelectedPdf(null);
  };

  return (
    <>
      <div className="banner-shareholding">
        <div className="overlay-shareholding" />
        <div className="banner-content animate__animated animate__fadeIn">
          <h1 className="h1-shareholding2">Red Herring Prospectus</h1>
        </div>
      </div>
      <br />
      <br />
      <section className="pdf-links">
        <h2>Red Herring Prospectus Reports</h2>
        <ul>
          {financialData.length === 0 ? (
            <li>
              No current financial data available. Please check back later.
            </li>
          ) : (
            financialData.map((data) => (
              <li key={data.year}>
                <div className="pdf-item">
                  <p className="year-title">
                    {data.title} - {data.year}
                  </p>
                  <a
                    href={data.file}
                    className="view-link"
                    onClick={() => handleViewClick(data.file)}
                  >
                    <FaArrowRight />{" "}
                  </a>
                </div>
              </li>
            ))
          )}
        </ul>
      </section>
    </>
  );
}

export default Redherringprospectus;
